var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import gql from "graphql-tag";
import * as React from "react";
import { Query } from "react-apollo";
import { CommentFragments, ReplyFragments } from "../../fragments";
export var getCommentWithRepliesByIdQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetCommentWithRepliesByIdQuery($commentId: String!) {\n    getCommentWithReplies(commentId: $commentId) @connection(key: \"CommentWithRepliesConnection\", filter: [\"commentId\"]) {\n      ...CommentFragments_commentWithReplies\n    }\n  }\n  ", "\n"], ["\n  query GetCommentWithRepliesByIdQuery($commentId: String!) {\n    getCommentWithReplies(commentId: $commentId) @connection(key: \"CommentWithRepliesConnection\", filter: [\"commentId\"]) {\n      ...CommentFragments_commentWithReplies\n    }\n  }\n  ", "\n"])), CommentFragments.commentWithReplies);
var newReplySubscription = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  subscription NewReplySubscription($commentId: String!) {\n    newReply(commentId: $commentId) {\n      ...ReplyFragments_reply\n    }\n  }\n  ", "\n"], ["\n  subscription NewReplySubscription($commentId: String!) {\n    newReply(commentId: $commentId) {\n      ...ReplyFragments_reply\n    }\n  }\n  ", "\n"])), ReplyFragments.reply);
var CommentWithReplyListController = /** @class */ (function (_super) {
    __extends(CommentWithReplyListController, _super);
    function CommentWithReplyListController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentWithReplyListController.prototype.render = function () {
        var _a = this.props, children = _a.children, commentId = _a.commentId;
        return (React.createElement(Query, { query: getCommentWithRepliesByIdQuery, variables: { commentId: commentId }, fetchPolicy: "cache-and-network" }, function (_a) {
            var data = _a.data, loading = _a.loading, subscribeToMore = _a.subscribeToMore;
            var commentWithReplies = null;
            if (data && !loading && data.getCommentWithReplies) {
                commentWithReplies = data.getCommentWithReplies;
            }
            return children({
                commentWithReplies: commentWithReplies,
                commentWithRepliesLoading: loading,
                subscribe: function () {
                    return subscribeToMore({
                        document: newReplySubscription,
                        variables: { commentId: commentId },
                        updateQuery: function (prev, _a) {
                            var subscriptionData = _a.subscriptionData;
                            if (!subscriptionData.data) {
                                return prev;
                            }
                            var newReply = subscriptionData.data.newReply;
                            if (prev.getCommentWithReplies &&
                                prev.getCommentWithReplies.replies) {
                                var replies = prev.getCommentWithReplies.replies;
                                var index = replies.findIndex(function (reply) { return reply.id === newReply.id; });
                                if (index === -1) {
                                    replies = [newReply].concat(replies);
                                }
                                return __assign({}, prev, { getCommentWithReplies: __assign({}, prev.getCommentWithReplies, { replies: replies }) });
                            }
                            return prev;
                        }
                    });
                }
            });
        }));
    };
    return CommentWithReplyListController;
}(React.PureComponent));
export { CommentWithReplyListController };
var templateObject_1, templateObject_2;
//# sourceMappingURL=CommentWithReplyListController.js.map


//////////////////
// WEBPACK FOOTER
// ../controller/dist/modules/comment/CommentWithReplyListController.js
// module id = 505
// module chunks = 0